// Automatically imports svgs as react components handled in next.config.js

// imports
import Logo from "./logo.svg";
import LogoWhite from "./LogoWhite.svg";
import AiDriven from "./AiDriven.svg";
import CompanyOverview1 from "./CompanyOverview1.svg";
import CompanyOverview2 from "./CompanyOverview2.svg";
import RightGuidance from "./RightGuidance.svg";
import Strategy from "./Strategy.svg";
import MCompanyOver2 from "./MCompanyOver2.svg";
import Revolutionize from "./Revolutionize.svg";
import Expertise1 from "./Expertise1.svg";
import Expertise2 from "./Expertise2.svg";
import Feature1 from "./Feature1.svg";
import Feature2 from "./Feature2.svg";
import Feature3 from "./Feature3.svg";
import Feature4 from "./Feature4.svg";
import Innovate from "./Innovate.svg";
import Secure2 from "./Secure2.svg";
import AiStrategy from "./AiStrategy.svg";
import AiiLogo from "./AiiLogo.svg";
import ArrowCircle from "./ArrowCircle.svg";
import HubIQ from "./HubIQ.svg";
import GovernAI from "./GovernAI.svg";
import CyberScore from "./CyberScore.svg";
import DefendAI from "./DefendAI.svg";
import CyberAtlas from "./CyberAtlas.svg";
import SecureCohort from "./SecureCohort.svg";
import EazyAudit from "./EazyAudit.svg";
import InsightGrid from "./InsightGrid.svg";
import Autocert from "./Autocert.svg";
import ApplyCyber from "./ApplyCyber.svg";
import ServicesSection from "./ServicesSection.svg";
import AiLogo from "./AiLogo.svg";
import CyberSecurity from "./CyberSecurity.svg";
import Scanner from "./FingerPrintScanner.svg";
import Offensive1 from "./Offensive1.svg";
import Offensive2 from "./Offensive2.svg";
import Offensive3 from "./Offensive3.svg";
import Defensive1 from "./Defensive1.svg";
import Defensive2 from "./Defensive2.svg";
import Defensive3 from "./Defensive3.svg";
import Integrated1 from "./Integrated1.svg";
import Integrated2 from "./Integrated2.svg";
import Integrated3 from "./Integrated3.svg";
import Strategy1 from "./Strategy1.svg";
import Strategy2 from "./Strategy2.svg";
import Strategy3 from "./Strategy3.svg";
import Visualization1 from "./Visualization1.svg";
import Visualization2 from "./Visualization2.svg";
import Visualization3 from "./Visualization3.svg";
import AiData1 from "./AiData1.svg";
import AiData2 from "./AiData2.svg";
import AiData3 from "./AiData3.svg";
import Defensive from "./Defensive.svg";
import HealthCare from "./HealthCare.svg";
import IntegratedSecurity from "./IntegratedSecurity.svg";
import ArtBoard from "./ArtBoard.svg";
import DataSecurity from "./DataSecurity.svg";
import AboutDots from "./AboutDots.svg";
import Secure3 from "./Secure3.svg";
import AboutUs from "./AboutUs.svg";
import Proposition1 from './Proposition1.svg';
import Proposition2 from './Proposition2.svg';
import Proposition3 from './Proposition3.svg';

// exports
export {
  Logo,
  LogoWhite,
  AiDriven,
  CompanyOverview1,
  CompanyOverview2,
  RightGuidance,
  Strategy,
  MCompanyOver2,
  Revolutionize,
  Expertise1,
  Expertise2,
  Feature1,
  Feature2,
  Feature3,
  Feature4,
  Innovate,
  Secure2,
  AiStrategy,
  AiiLogo,
  ArrowCircle,
  HubIQ,
  GovernAI,
  CyberScore,
  DefendAI,
  CyberAtlas,
  SecureCohort,
  EazyAudit,
  InsightGrid,
  Autocert,
  ApplyCyber,
  ServicesSection,
  AiLogo,
  CyberSecurity,
  Scanner,
  Offensive1,
  Offensive2,
  Offensive3,
  Defensive1,
  Defensive2,
  Defensive3,
  Integrated1,
  Integrated2,
  Integrated3,
  Strategy1,
  Strategy2,
  Strategy3,
  Visualization1,
  Visualization2,
  Visualization3,
  AiData1,
  AiData2,
  AiData3,
  Defensive,
  HealthCare,
  IntegratedSecurity,
  ArtBoard,
  DataSecurity,
  AboutDots,
  AboutUs,
  Secure3,
  Proposition1,
  Proposition2,
  Proposition3
};
